module.exports = __webpack_public_path__ + "static/crisweb-project-aaf9bff1fcee56e1a8d67bc9d3a7f52d.png";